"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeSizes = exports.Shapes = exports.DotSizes = exports.DashSizes = exports.Sizes = exports.MINIMUM_CLICKABLE_HEIGHT = void 0;

var _designLanguage = require("@doordash/design-language");

var _ShapeSizes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MINIMUM_CLICKABLE_HEIGHT = 36;
exports.MINIMUM_CLICKABLE_HEIGHT = MINIMUM_CLICKABLE_HEIGHT;
var Sizes = {
  Large: 'Large',
  Medium: 'Medium',
  Small: 'Small'
};
exports.Sizes = Sizes;
var DashSizes = {
  Large: {
    height: 8,
    width: 32,
    spacing: _designLanguage.InlineChildren.Sizes.XSmall
  },
  Medium: {
    height: 6,
    width: 24,
    spacing: _designLanguage.InlineChildren.Sizes.XxSmall
  },
  Small: {
    height: 4,
    width: 16,
    spacing: _designLanguage.InlineChildren.Sizes.XxSmall
  }
};
exports.DashSizes = DashSizes;
var DotSizes = {
  Large: {
    height: 10,
    width: 10,
    spacing: _designLanguage.InlineChildren.Sizes.XxSmall
  },
  Medium: {
    height: 8,
    width: 8,
    spacing: _designLanguage.InlineChildren.Sizes.XxSmall
  },
  Small: {
    height: 6,
    width: 6,
    spacing: _designLanguage.InlineChildren.Sizes.XxxSmall
  }
};
exports.DotSizes = DotSizes;
var Shapes = {
  Dash: 'Dash',
  Dot: 'Dot'
};
exports.Shapes = Shapes;
var ShapeSizes = (_ShapeSizes = {}, _defineProperty(_ShapeSizes, Shapes.Dash, DashSizes), _defineProperty(_ShapeSizes, Shapes.Dot, DotSizes), _ShapeSizes);
exports.ShapeSizes = ShapeSizes;